// extracted by mini-css-extract-plugin
export default {"header":"created-giftcard-modal_header__3WBgr","content":"created-giftcard-modal_content__LR8Qu","spacer":"created-giftcard-modal_spacer__rgi8r"};